import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../pages/css/LeadDatabase.css";
import banner from '../images/Hrias-b2b-banner.png';
import verified90 from '../images/hrias-multi-b2c-5.png';
import filtersb2b from '../images/hrias-multi-b2c-6.png'
import intentSignal from '../images/Hrias-Intent_Signal.png';
import outreach from '../images/Hrias-b2b-outreach.png'
import b2bcrm from '../images/Hrias-b2b-CRM.png';
import customDev from '../images/Hrias-Custom_Development.png';
import cTOne from '../images/kpmg.png';
import cTTwo from '../images/deloite.png';
import cTThree from '../images/berkshire.png';
import cTFive from '../images/pwc.jpg';
import cTSix from '../images/microsoft.png';
import cTFour from '../images/Google.png';
import dashImg from '../images/hrias-multi-b2c-4.png';
import { useNavigate } from "react-router-dom";


function B2cLeadDatabase() {
  const navigate = useNavigate();
  return (
    <div className="b2b-lead-page">
      {/* Hero Section */}
      <section
        className="hero-section text-center text-white d-flex align-items-center justify-content-center"
        style={{
          backgroundImage:
            `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          height: "40vh",
        }}
      >
        <div className="container" style={{ color: "#ffffff" }}>
          <h1 className="fw-bold" style={{ color: "#275a8eff" }}>
            Find, Engage & Convert <span className="highlight" style={{ color: "#7102c1ff" }}>Verified B2C Leads</span> with HRIAS
          </h1>
          <p className="lead mt-3" style={{ color: "#890059ff" }}>
            Access a global database of verified contacts, Facebook, Instagram, and AI-powered tools — built to supercharge your outbound strategy.
          </p>
          <button
            className="btn btn-primary mt-4"
            style={{
              backgroundColor: "#134373ff",
              border: "none",
              color: "#ffffffff",
              fontWeight: "600",
              borderRadius: "30px",
              padding: "12px 30px",
              transition: "all 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#5197dcff")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#134373ff")}
            onClick={() => navigate("/contact-us-hrias")}
          >
            Contact Sales
          </button>
        </div>

      </section>
      <section>
        <div className="container py-5">
          <img
            src={dashImg}
            alt="Padded Container"
            className="img-fluid rounded shadow-lg"
          />
        </div>
      </section>
      <section className="container my-5 partner-section">
        {/* Heading */}
        <h5 className="text-center partner-heading">
          Trusted by <span style={{ color: '#fd7e14' }}>6000+</span> Industry Leaders
        </h5>

        {/* Logo Row */}
        <div className="d-flex justify-content-center align-items-center flex-wrap gap-4 mt-4">
          <img src={cTOne} alt="KPMG" className="partner-logo" style={{ width: '120px', height: 'auto' }} />
          <img src={cTTwo} alt="Deloitte" className="partner-logo" style={{ width: '130px', height: 'auto' }} />
          <img src={cTThree} alt="Berkshire" className="partner-logo" />
          <img src={cTFour} alt="Google" className="partner-logo" />
          <img src={cTFive} alt="PwC" className="partner-logo" />
          <img src={cTSix} alt="Microsoft" className="partner-logo" />
        </div>
      </section>


      {/* Section 1 — Verified B2B Contacts */}
      <section className="feature-section py-5 bg-light">
        <div className="container d-flex flex-column flex-md-row align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-md-start">
            <h3 className="feature-title">Access 90% Verified B2C Contacts</h3>
            <p className="feature-text">
              HRIAS gives you instant access to verified contact databases across
              industries and regions. Each lead includes facebook, Instagram ID,
              location, occupation, hobbies.
            </p>
            <button className="btn btn-outline-primary">Explore Leads</button>
          </div>
          <div className="col-md-6 text-center">
            <img
              src={verified90}
              alt="Verified Leads"
              className="img-fluid rounded shadow-sm"
            />
          </div>
        </div>
      </section>

      {/* Section 2 — Smart Filters & Advanced Search */}
      <section className="feature-section py-5">
        <div className="container d-flex flex-column flex-md-row-reverse align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-md-start" style={{ marginLeft: '20px' }}>
            <h3 className="feature-title">Smart Filters & Advanced Search</h3>
            <p className="feature-text">
              Filter leads by role, location, company type, industry, or intent.
              Instantly identify your best-fit prospects with our AI-powered
              filtering and segmentation tools.
            </p>
            <button className="btn btn-outline-primary">See Filters</button>
          </div>
          <div className="col-md-6 text-center" >
            <img
              src={filtersb2b}
              alt="Smart Filters"
              className="img-fluid rounded shadow-sm"
            />
          </div>
        </div>
      </section>

      {/* Section 3 — Real-Time Intent Signals */}
      <section className="feature-section py-5 bg-light">
        <div className="container d-flex flex-column flex-md-row align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-md-start">
            <h3 className="feature-title">Track Real-Time Intent Signals</h3>
            <p className="feature-text">
              Get real-time company updates — from job postings and website
              changes to press releases and reviews. Identify buying intent
              before competitors reach out.
            </p>
            <button className="btn btn-outline-primary">View Insights</button>
          </div>
          <div className="col-md-6 text-center">
            <img
              src={intentSignal}
              alt="Intent Signals"
              className="img-fluid rounded shadow-sm"
            />
          </div>
        </div>
      </section>

      {/* Section 4 — Automated Multi-Channel Outreach */}
      <section className="feature-section py-5">
        <div className="container d-flex flex-column flex-md-row-reverse align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-md-start" style={{ marginLeft: '20px' }}>
            <h3 className="feature-title">Automate Multi-Channel Outreach</h3>
            <p className="feature-text">
              Send personalized outreach automatically across Facebook, Instagram,
              WhatsApp, and Calls. Manage all communications in one unified
              inbox without switching platforms.
            </p>
            <button className="btn btn-outline-primary">Automate Now</button>
          </div>
          <div className="col-md-6 text-center">
            <img
              src={outreach}
              alt="Outreach Automation"
              className="img-fluid rounded shadow-sm"
            />
          </div>
        </div>
      </section>

      {/* Section 5 — CRM & Integrations */}
      <section className="feature-section py-5 bg-light">
        <div className="container d-flex flex-column flex-md-row align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-md-start">
            <h3 className="feature-title">Integrated CRM & Smart Analytics</h3>
            <p className="feature-text">
              Track your facebook opens, clicks, replies, and conversions — directly
              inside the HRIAS dashboard. Seamlessly integrate with HubSpot,
              Salesforce, or export data via CSV.
            </p>
            <button className="btn btn-outline-primary">View Dashboard</button>
          </div>
          <div className="col-md-6 text-center">
            <img
              src={b2bcrm}
              alt="CRM Integration"
              className="img-fluid rounded shadow-sm"
            />
          </div>
        </div>
      </section>

      {/* Section 6 — Custom Development & Add-ons */}
      <section className="feature-section py-5">
        <div className="container d-flex flex-column flex-md-row-reverse align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 text-md-start" style={{ marginLeft: '20px' }}>
            <h3 className="feature-title">Custom Development for Your Needs</h3>
            <p className="feature-text">
              Need extra functionality? HRIAS can develop custom modules like
              AI-enhanced filters, call tracking dashboards, or lead scoring
              algorithms tailored to your business.
            </p>
            <button className="btn btn-outline-primary">Request Customization</button>
          </div>
          <div className="col-md-6 text-center">
            <img
              src={customDev}
              alt="Custom Development"
              className="img-fluid rounded shadow-sm"
            />
          </div>
        </div>
      </section>

      <section className="container my-5 client-review-section">
        <div className="row align-items-center">
          {/* Left side - client image */}
          <div className="col-12 col-md-3 text-center">
            <img
              src="https://img.freepik.com/free-photo/brunette-business-woman-with-wavy-long-hair-blue-eyes-stands-holding-notebook-hands_197531-343.jpg" // replace with your client's photo
              alt="Client"
              className="client-img"
            />
          </div>

          {/* Right side - review text */}
          <div className="col-12 col-md-9">
            <p className="client-review">
              “HRIAS Verified B2C Lead Database has transformed the way we reach customers across WhatsApp, Facebook, Instagram, and even direct calls.
              The lead accuracy is outstanding — no more irrelevant or outdated contacts.
              Our outreach has become faster, more targeted, and incredibly effective, resulting in a noticeable boost in conversions and customer engagement!”
            </p>
            <h3 className="client-name">Olivia Bennett</h3>
            <p className="client-position">Growth Marketing Manager, StellarLane Enterprises</p>


          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section text-center py-5">
        <div className="container">
          <h2 className="cta-title fw-bold mb-3 text-white">
            Start Building Your B2C Pipeline with Confidence
          </h2>
          <p className="cta-subtitle mt-3 mb-4">
            Get verified leads, real-time insights, and AI-powered automation
            with HRIAS — the smarter way to grow your sales.
          </p>
          <button className="btn btn-primary px-4 py-2" >Contact Sales</button>
        </div>
      </section>
    </div>
  );
}

export default B2cLeadDatabase;
